import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IMAGES } from "../config";

export default function RentalGuidelines() {
  return (
    <div className="min-h-screen bg-offwhite text-charcoal">
      <div className="max-w-[860px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-charcoal/70 hover:text-plum transition-colors mb-10" data-testid="rg-back">
          <ArrowLeft size={16} strokeWidth={1.6} /> Back to Home
        </Link>
        <img src={IMAGES.logo} alt="DMEDIA CLUB logo" className="h-9 w-auto mb-8" />
        <p className="overline text-plum">Rental Guidelines</p>
        <h1 className="display text-4xl sm:text-5xl mt-5 mb-8 leading-[1.02]">Rental Guidelines</h1>
        <div className="space-y-6 text-base text-charcoal/75 leading-relaxed">
          <p>
            DMEDIA CLUB reserves the right to reclassify a reservation as a Curated Brand Experience when
            the proposed use includes vendors, sponsors, retail sales, product displays, refreshments,
            ticketed attendance, guest activations, customized installations or other event-style
            elements. Any resulting difference in pricing and reservation requirements must be paid
            before the reservation is confirmed.
          </p>
          <p>
            DMEDIA CLUB is a creative space for approved workshops, classes, movement sessions, business
            training, professional presentations, and curated brand experiences. Parties and social
            celebrations are not permitted.
          </p>
          <p>
            A DMEDIA CLUB representative remains onsite during every reservation. Setup, guest arrival,
            the reserved activity, and cleanup must all happen within the reserved time. Final layouts
            and capacity are reviewed and approved by DMEDIA CLUB.
          </p>
        </div>
      </div>
    </div>
  );
}
